import type { ChatMessage, GroupedMessage } from "./types";

export function groupMessages(messages: ChatMessage[]): GroupedMessage[] {
  return messages.map((m, i) => {
    const next = messages[i + 1];
    const isLastOfGroup =
      !next ||
      next.from !== m.from ||
      next.kind === "action" ||
      m.kind === "action";
    return { ...m, isLastOfGroup } as GroupedMessage;
  });
}
